/**
 * Builds the Health Auto Export Google OAuth handoff URL (`com.HealthExport://google`).
 * Legacy vs v2 behavior must stay aligned with `BusinessLogic.md` (CRA deep link contract).
 *
 * @param {object} input
 * @param {boolean} input.useV2 - True when `REACT_APP_GOOGLE_OAUTH_V2 === "1"`.
 * @param {string|null|undefined} input.accessToken
 * @param {string|null|undefined} input.refreshToken
 * @param {string|null|undefined} input.expDate - Stored expiry (typically Google `expiry_date`).
 * @param {string} [input.googleAccountID=""]
 * @param {string} [input.googleAccountEmail=""]
 * @param {string} [input.oauthProfile=""] - From redirect JSON: `"legacy"` | `"v2"` (server `authHandler.js`).
 * @param {Date} [input.now] - Optional clock for v2 invalid-expiry fallback (tests only).
 * @returns {string}
 */
export function buildHealthAutoExportDeepLink(input) {
  const {
    useV2,
    accessToken,
    refreshToken,
    expDate,
    googleAccountID = "",
    googleAccountEmail = "",
    oauthProfile = "",
    now,
  } = input;

  const haeURL = "com.HealthExport://google";

  if (!useV2) {
    const date = new Date(Number(expDate));
    const dateString = date.toISOString();
    let url = `${haeURL}?accessToken=${accessToken}&refreshToken=${refreshToken}&expirationDate=${dateString}`;
    if (oauthProfile) {
      url += `&oauthProfile=${encodeURIComponent(oauthProfile)}`;
    }
    return url;
  }

  const dateValue = new Date(expDate);
  const expirationDate = Number.isNaN(dateValue.getTime())
    ? (now instanceof Date ? now : new Date()).toISOString()
    : dateValue.toISOString();

  const params = new URLSearchParams({
    accessToken: accessToken || "",
    refreshToken: refreshToken || "",
    expirationDate,
    googleAccountID,
    googleAccountEmail,
  });
  if (oauthProfile) {
    params.set("oauthProfile", oauthProfile);
  }
  return `${haeURL}?${params.toString()}`;
}
